import styled from 'styled-components';
import { AlertTitle } from 'assets/styles/sharedStyles';

export const StyledTitle = styled(AlertTitle)`
  margin-bottom: 10px;
`;
